import React from 'react';
import PropTypes from 'prop-types';

import { ArrowDropDown } from '@material-ui/icons';
import { Select } from '@knockrentals/knock-shared-web';

import './_SettingSelect.scss';

export const SettingSelect = ({
  handleOnSelect,
  id,
  isDisabled,
  options,
  value,
}) => {
  const getSelectClass = () => {
    if (isDisabled) return 'setting-select-disabled';
    return 'setting-select';
  };

  const GreyArrowIcon = (props) => (
    <ArrowDropDown {...props} style={{ color: 'rgba(0, 0, 0, 0.38)' }} />
  );

  return (
    <div className="setting-select-wrapper">
      <Select
        className={getSelectClass()}
        defaultValue={value}
        disabled={isDisabled}
        IconComponent={isDisabled ? GreyArrowIcon : ArrowDropDown}
        id={id}
        noForm
        onSelectChange={handleOnSelect}
        options={options}
        value={value}
      />
    </div>
  );
};

SettingSelect.propTypes = {
  handleOnSelect: PropTypes.func.isRequired,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isGrey: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string.isRequired,
};
